import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      unwatch: null,
      triggers: [],
    }
  },
  computed: {
    ...mapGetters({
      'isNavigationBrighten': 'pageNavigation/isBrighten',
    }),
  },
  mounted() {
    this.unwatch = this.$watch('$window.scrollY', () => {
      [].forEach.call(this.triggers, (trigger) => {
        if(this.$_navigationSwitch_isOutOfView(trigger)) {
          return
        }

        if(trigger.getBoundingClientRect().top <= this.$window.height / 2) {
          if(!this.isNavigationBrighten) {
            this.setBrightness(true)
          }
        }

        if(trigger.getBoundingClientRect().top < (-trigger.clientHeight / 2)) {
          if(this.isNavigationBrighten) {
            this.setBrightness(false)
          }
        }
      })
    })
  },
  beforeDestroy() {
    this.unwatch()
  },
  methods: {
    $_navigationSwitch_setTriggers(selector) {
      this.triggers = document.querySelectorAll(selector)
    },
    $_navigationSwitch_isOutOfView(element) {
      return (
        element.getBoundingClientRect().top > this.$window.height || 
        element.getBoundingClientRect().top < -element.clientHeight
      )
    },
    ...mapMutations({
      'setBrightness': 'pageNavigation/SET_BRIGHTNESS',
    }),
  }
}


// WEBPACK FOOTER //
// ./src/mixins/navigation-switch.js